"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = ['loading', 'loaded', 'intersect', 'pagination', 'filter', 'sorted', 'select', 'row-click'];
exports["default"] = _default;